import { View } from "react-native";
import React from "react";
import BaseCard, { BaseCardListItem } from "components/BaseCard";
import {
  PlanPackageDetails,
  SignupChargeDetails,
  SubscriptionDetails,
} from "features/types";
import { Text } from "@ui-kitten/components";
import PaymentMethodCard from "screens/Account/components/PaymentMethodCard";
import toast from "utils/toast";
import ConfirmPurchaseButton from "components/ConfirmPurchaseButton";
import { PlanChanges } from "../types";
import { useAppDispatch } from "hooks/useAppDispatch";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { ManageSubscriptionsStackParamList } from "navigation/types";
import { setStep } from "features/slices/buyFlowSlice";
import Spacer from "components/Spacer";
import { resetReservationFlow } from "features/slices/reservationFlowSlice";
import { useAccount } from "hooks/useAccount";
import { useMutation } from "@tanstack/react-query";
import { changeSubscriptionsFetcher } from "queries/account.queries";
import BuyFlowPaymentDetailCard from "components/BuyFlowPaymentDetailCard";

interface UpgradePlanStepTwoProps {
  planChangeCharge: SignupChargeDetails;
  selectedUpgradePlan: PlanPackageDetails;
  selectedSubscription: SubscriptionDetails;
  planChanges: PlanChanges;
}

const UpgradePlanStepTwo: React.FC<UpgradePlanStepTwoProps> = ({
  planChangeCharge,
  selectedSubscription,
  selectedUpgradePlan,
  planChanges,
}) => {
  const { account, fetchAccount } = useAccount();

  if (!account) return null;
  const { subscriptions } = account;
  const dispatch = useAppDispatch();
  const navigation =
    useNavigation<NavigationProp<ManageSubscriptionsStackParamList>>();
  const { mutateAsync: changeSubscriptions, isLoading: loading } = useMutation(
    changeSubscriptionsFetcher
  );
  const sameSubscriptionsInAccount = subscriptions.filter(
    (sub) =>
      !sub.expired && sub.planPackage.id === selectedSubscription.planPackage.id
  );

  const handleBtnPress = async () => {
    await changeSubscriptions({
      accountId: account.id,
      changes: planChanges,
      source: "FANRALLY_APP",
    });
    fetchAccount();
    dispatch(resetReservationFlow());
    dispatch(setStep(1));
    navigation.navigate("ManageSubscriptionsScreen");
    toast.success("Congratulations, your plan has been successfully changed.");
  };

  return (
    <View>
      <BaseCard title="Switching Plans">
        <View style={{ marginTop: 25 }}>
          <Text>Current plan:</Text>
          <Text category="h6" style={{ marginVertical: 5 }}>
            {selectedSubscription.planPackage.name}
          </Text>
          <Text>Switching to:</Text>
          <Text category="h6" style={{ marginVertical: 5 }}>
            {selectedUpgradePlan.name}
          </Text>
        </View>
        <BaseCardListItem
          showArrow={false}
          title={`Total Quantity: ${sameSubscriptionsInAccount.length}`}
        />
      </BaseCard>

      <Spacer />

      <BuyFlowPaymentDetailCard planPackage={selectedUpgradePlan} />

      <Spacer />

      <PaymentMethodCard />

      <Spacer />

      <ConfirmPurchaseButton
        charge={parseFloat(planChangeCharge.signupCharge)}
        buttonText="Confirm Upgrade"
        onPress={handleBtnPress}
        loading={loading}
        disabled={loading}
      />
    </View>
  );
};

export default UpgradePlanStepTwo;
